import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';
import { useAzureData } from './AzureContext';
import {
  checkPromptNameAvailability,
  creditAPI,
  getBusinessCategories,
  checkModelNameDuplication
} from '../service/apiServices';
import { Prev } from 'react-bootstrap/esm/PageItem';

type PromptContextType = {
  promptsList: string[];
  setPromptsList: React.Dispatch<React.SetStateAction<string[]>>;
  myPrompt: string;
  setSelectedApplication: any;
  setMyPrompt: React.Dispatch<React.SetStateAction<string>>;
  setDeduction: React.Dispatch<React.SetStateAction<number>>;
  deduction: number;

  //
  creditData: any;
  creditDataFunction: () => Promise<void>;

  // /
  selectedApplication: { credit_id: string };

  //

  modelNameDuplicationFunction: (a: string) => {};

  //
  businessCategoryFunction: () => {};
  businessCategories: any;

  //
  promptNameCheckFunction: (name: string) => {};

  //
  handleSetIndexData: (a: string, b: String) => void;
  indexSelection: { index: string; topK: number };
  resetIndexDetails: () => void;
  //
  IndexOptions: any;
};

const PromptContext = createContext<PromptContextType | undefined>(undefined);

export const PromptProvider = ({ children }: { children: ReactNode }) => {
  const { apiToken } = useAzureData();

  // prompt list for compare prompt page
  const [promptsList, setPromptsList] = useState<string[]>([]);

  // selected Prompt for fetching data
  const [myPrompt, setMyPrompt] = useState<string>('');

  const [creditData, setCreditData] = useState({
    data: {},
    loading: false,
    error: ''
  });

  //
  const [deduction, setDeduction] = useState(0);

  const creditDataFunction = async () => {
    setCreditData((prev) => ({ ...prev, loading: true }));
    try {
      const data = await creditAPI(apiToken);
      setCreditData((prev) => ({ ...prev, data: data }));
    } catch (err) {
      setCreditData((prev) => ({ ...prev, error: err?.message || 'Something Went Wrong' }));
    } finally {
      setCreditData((prev) => ({ ...prev, loading: false }));
    }
  };
  const creditMemo = useMemo(() => ({ creditData, creditDataFunction }), [creditData]);

  //
  const [selectedApplication, setSelectedApplication] = useState({ credit_id: '' });

  //
  // nameCheck for ModelName
  //

  const modelNameDuplicationFunction = async (name: string) => {
    try {
      const data = await checkModelNameDuplication(apiToken, name);
      return data?.exists;
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  //   for business Category
  const [businessCategories, setBusinessCategories] = useState({
    data: [],
    loading: false,
    error: ''
  });

  const businessCategoryFunction = async () => {
    setBusinessCategories((prev) => ({ ...prev, loading: true }));
    try {
      const data = await getBusinessCategories(apiToken);
      const temp =
        data?.business_categories?.map((item) => ({
          title: item?.category_name,
          id: item?.category_name
        })) || [];
      setBusinessCategories((prev) => ({ ...prev, data: temp }));
    } catch (err) {
      setBusinessCategories((prev) => ({ ...prev, error: err }));
    } finally {
      setBusinessCategories((prev) => ({ ...prev, loading: false }));
    }
  };

  const BusinessCategoryMemo = useMemo(
    () => ({ businessCategoryFunction, businessCategories }),
    [businessCategories]
  );

  const promptNameCheckFunction = async (name: string) => {
    try {
      const data = await checkPromptNameAvailability(apiToken, name);

      return data;
    } catch (err) {
      return err;
    }
  };

  const [indexSelection, setIndexData] = useState({ index: '', topK: 0 });
  const handleSetIndexData = (field: any, value: any) => {
    setIndexData((prev) => ({ ...prev, [field]: value }));
  };
  const resetIndexDetails = () => {
    setIndexData({ index: '', topK: 0 });
  };

  const [IndexOptions, setIndexOption] = useState([{ title: '', id: '', serviceName: '' }]);

  return (
    <PromptContext.Provider
      value={{
        promptsList,
        setPromptsList,
        myPrompt,
        setMyPrompt,
        ...creditMemo,
        setSelectedApplication,
        selectedApplication,
        //
        deduction,
        setDeduction,
        // ...modelNameMemo
        modelNameDuplicationFunction,
        ...BusinessCategoryMemo,
        promptNameCheckFunction,
        handleSetIndexData,
        indexSelection,
        resetIndexDetails,
        IndexOptions,
        setIndexOption
      }}>
      {children}
    </PromptContext.Provider>
  );
};

export const usePromptContext = () => {
  const context = useContext(PromptContext);
  if (!context) {
    throw new Error('usePromptContext must be used within a PromptProvider');
  }
  return context;
};
